(function () {
  const root = document.documentElement;
  root.classList.add('np-js');

  const start = () => {
    if (document.body.dataset.npMotionReady === 'true') return;
    document.body.dataset.npMotionReady = 'true';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals = document.querySelectorAll('[data-np-reveal]');

    if (reducedMotion || !('IntersectionObserver' in window)) {
      reveals.forEach((item) => item.classList.add('is-visible'));
    } else {
      const revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
      );

      reveals.forEach((item) => revealObserver.observe(item));
    }

    const sentinel = document.querySelector('.np-scroll-sentinel');
    if (sentinel && 'IntersectionObserver' in window) {
      const headerObserver = new IntersectionObserver(([entry]) => {
        document.body.classList.toggle('np-has-scrolled', !entry.isIntersecting);
      });
      headerObserver.observe(sentinel);
    }

    if (!CSS.supports('animation-timeline: scroll()')) {
      let scheduled = false;
      const updateProgress = () => {
        const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
        root.style.setProperty('--np-scroll-progress', Math.min(1, window.scrollY / scrollable).toFixed(4));
        scheduled = false;
      };

      window.addEventListener(
        'scroll',
        () => {
          if (scheduled) return;
          scheduled = true;
          window.requestAnimationFrame(updateProgress);
        },
        { passive: true }
      );
      updateProgress();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
